export default __webpack_public_path__ + "tds-blue-icon.svg";